import { ArrowUpCircleIcon, ArrowUpIcon } from '@heroicons/react/24/solid';
import React, { useState, useEffect } from 'react';

function ScrollToTopButton(): JSX.Element {
  // State to manage the visibility of the button
  const [isVisible, setIsVisible] = useState<boolean>(false);

  // Handle scroll events
  useEffect(() => {
    function handleScroll(): void {
      // Show the button when the user scrolls down 300px or more
      setIsVisible(window.scrollY > 300);
    }

    // Add the scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Clean up the event listener on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Function to scroll to the top of the page
  const scrollToTop = (): void => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Render the button conditionally based on visibility
  return <>{isVisible && 
  <span className='fixed rounded-full h-42 border border-gray-400 w-42 bg-gray-200 bottom-20 md:bottom-40 right-20 z-[999]  hover:cursor-pointer flex items-center justify-center'>

  <ArrowUpIcon className="w-24 hover:cursor-pointer" onClick={scrollToTop} />
  </span>
  }</>;
}

export default ScrollToTopButton;
